export default __webpack_public_path__ + "static/media/front-page-small.dd5a4dca.jpg";